import { audiences } from "@/mocks/landing";

export default function AudienceSection() {
  return (
    <section id="publico" className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Para quem é
          </h2>
          <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto">
            FloraIQ foi desenvolvido para organizações que precisam de inteligência geográfica e gestão técnica do patrimônio verde urbano.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {audiences.map((audience) => (
            <div
              key={audience.label}
              className="flex items-center gap-3 bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-300/60 transition-colors"
            >
              <div className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-50 flex items-center justify-center shrink-0">
                <i className={`${audience.icon} text-primary-600 w-full h-full flex items-center justify-center`} />
              </div>
              <span className="text-sm font-medium text-foreground-800 leading-tight">
                {audience.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}